import type { TOC } from '@ember/component/template-only';
import { PrismIllustration } from '@mylighthouse/prism-ember';
import type { StepperPanelStep } from 'lumen/components/hotel/benchmark-insight/competitors/compset-builder/stepper-panel-step';
import HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelStep from 'lumen/components/hotel/benchmark-insight/competitors/compset-builder/stepper-panel-step';

interface HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelSignature {
  Args: {
    description?: string;
    steps: StepperPanelStep[];
    title: string;
  };
}

const HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanel = <template>
  <div
    class="stepper-panel bg-level-1 flex h-full w-full flex-col gap-600 p-600"
  >
    <div class="flex flex-row items-start gap-300">
      <PrismIllustration @name="40x40_automation-lightbulb" @size="small" />

      <div class="flex flex-col gap-100">
        <h3>{{@title}}</h3>
        <p class="text-200--regular text-neutral-subdued">{{@description}}</p>
      </div>
    </div>

    {{#each @steps as |step|}}
      <HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelStep
        @step={{step}}
      />
    {{/each}}
  </div>
</template> satisfies TOC<HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelSignature>;

export default HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanel;
